export const styles = theme => ({
    frameTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems:'center'
    },
    iconWrap: {
        fontSize: 40,
        float : 'right',
        cursor : 'pointer',
        padding: '4px'
    },
    icon: {
        fontSize: 40,
        float : 'right',
        cursor : 'pointer'
      },
    //   modify
    iconRoot:{
        color:'#292f48'
    },
    titleCustomer:{
        // fontSize:34,
        // color: '#292f48',
        // fontWeight: '500'
    },
    titleChart:{
         marginTop: '2.5rem',
         marginBottom: '1.5rem',
         fontWeight: 'bold',
         color: '#292f48',
         textAlign: 'center'
    },
    TypoTitle: {
        fontWeight: '500'
    }
})